export default "__VITE_ASSET__DJ6VXXdS__"